import { Routes, Route } from 'react-router';
import { MerchantSettings } from './merchant/merchant-settings';
import { ProfileSettings } from './profile-settings';
import { AdminSettings } from './admin/admin-settings';

export function SettingsPage() {
  return (
    <Routes>
      <Route path="profile" element={<ProfileSettings />} />
      <Route path="merchant" element={<MerchantSettings />} />
      <Route path="admin" element={<AdminSettings />} />
    </Routes>
  );
}
